module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"protrusion-role":{"SELLER":"Vendeur","STUD":"Haras","BROKER":"Courtier","UNKNOWN":"Autre"}}}')
  delete Component.options._Ctor
}
